import React from "react";
import { twMerge } from "tailwind-merge";
import { CMSData } from "@/cms/models";
import { GetFont } from "@/utils/helper";
import TextField from "@mui/material/TextField";

interface DateInputProps {
  required: boolean;
  label: string;
  defaultValue: string;
  errors: string[] | undefined;
  name: string;
  className?: string;
  cmsData: CMSData;
}

const DateInput: React.FC<DateInputProps> = ({
  required,
  label,
  defaultValue,
  errors,
  name,
  className = "",
  cmsData,
}) => {
  const style = cmsData.forms.style;
  const fontFamily = GetFont(cmsData.theme.fontType).style.fontFamily;
  const renderTextField = (variant: any) => (
    <TextField
      required={required}
      error={!!errors}
      type="date"
      className={twMerge("flex col-span-3 flex-col ", className)}
      label={label}
      size={style?.size}
      variant={variant}
      defaultValue={defaultValue}
      name={name}
      helperText={errors ? errors.join(", ") : undefined}
      slotProps={{
        inputLabel: {
          className: `homepage-text-sm`,
          style: { fontFamily: fontFamily },
        },
        input: {
          className: `${variant === "outlined" ? "bg-white" : ""} homepage-text-sm`,
          style: { fontFamily: fontFamily },
        },
        formHelperText: {
          style: { fontFamily: fontFamily },
        },
      }}
    />
  );
  switch (style?.type) {
    case "material-outlined":
      return renderTextField("outlined");
    case "material-standard":
      return renderTextField("standard");
    default:
      return renderTextField("filled");
  }
};

export default DateInput;
